export class SearchTaskDocHeaderRequest {
  doNoList: string[];
  taskClassName: string;
  bookingNo: string[];

  constructor() {
    this.doNoList = [];
    this.taskClassName = "";
    this.bookingNo = [];
  }


}
